import { filterValueToQuery } from '@/api';

export default function dashboard(axios: any) {
  async function getDashboard(filter: any) {
    try {
      const response = await axios.get(`/api/dashboard?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/expense] getExpenses Error', e);
    }
    return null;
  }

  return {
    getDashboard,
  };
}
